/**
 * /discover — full-screen Scout page.
 *
 * Used for direct shares ("hey, check this out: theailedger.ai/discover")
 * and as the destination of the homepage hero CTA. The bottom-right
 * <ScoutFloatingButton> hides itself when on this route to avoid
 * redundancy.
 */
import React from 'react';
import { Sparkles } from 'lucide-react';
import ScoutDiscover from '../components/ScoutDiscover';

export default function Discover() {
  return (
    <div
      data-testid="discover-page"
      className="min-h-screen bg-black text-white"
    >
      <section className="relative pt-16 pb-12 px-6 md:px-12">
        <div className="hero-glow absolute inset-0 pointer-events-none"></div>
        <div className="container mx-auto max-w-5xl text-center relative">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-cyan-400/30 bg-cyan-400/5 text-cyan-300 text-xs font-semibold tracking-wider uppercase mb-5">
            <Sparkles className="w-3.5 h-3.5" />
            Meet Scout
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4 tracking-tight">
            What can I help you find?
          </h1>
          <p className="text-neutral-400 text-base sm:text-lg max-w-2xl mx-auto mb-10">
            Tell Scout what you're trying to get done. It searches every
            product and partner tool on the platform and brings back the two
            or three options that actually fit — with honest pros and cons.
          </p>
        </div>
      </section>

      <section className="px-6 md:px-12 pb-24">
        <ScoutDiscover variant="page" autoFocus />
      </section>
    </div>
  );
}
